const MAX_POSITION_OFFSET = 75;

function toPercents(position) {
  return `${position[0]}% ${position[1]}%`;
}

function calculateNewItemPosition(compositionGroupNode) {
  const initialPosition = [50, 50];
  let position = [...initialPosition];
  const step = 2.5;
  let shift = 0;

  let compositionItem = compositionGroupNode.firstElementChild;

  while (compositionItem) {
    const itemPosition = compositionItem.getAttribute('position');

    if (itemPosition === toPercents(position)) {
      position[0] += step;
      position[1] += step;

      if (position[0] > MAX_POSITION_OFFSET + shift || position[1] > MAX_POSITION_OFFSET) {
        shift += step;
        position = [...initialPosition];
        break;
      }
    }

    compositionItem = compositionItem.nextElementSibling;
  }

  return toPercents(position);
}

export default calculateNewItemPosition;
